'use client';

import { cn, TRadioButtonProps } from 'types';

export const RadioButton = ({
  checked = false,
  className = '',
  labelClassName = '',
  disabled = false,
  id,
  label,
  onClick,
  onChange,
}: Partial<TRadioButtonProps>) => {
  const handleOnClick = (e: any) => {
    if (typeof onClick === 'function') {
      onClick(e);
    }
  };

  const handleOnChange = (e: any) => {
    if (typeof onChange === 'function') {
      onChange(e);
    }
  };

  return (
    <div className={cn('group flex items-center gap-2 relative w-fit', className)}>
      <input
        id={id}
        name={label}
        type="radio"
        onClick={(e) => handleOnClick(e)}
        onChange={(e) => handleOnChange(e)}
        checked={checked}
        disabled={disabled}
        className="absolute opacity-0 w-0 h-0"
      />
      <label
        htmlFor={id}
        className={cn(
          'w-[1.375rem] h-[1.375rem] rounded-full border-2 flex items-center justify-center',
          disabled ? 'border-neutralPlus cursor-default' : 'border-black cursor-pointer'
        )}
      >
        <span
          className={cn(
            'w-3 h-3 rounded-full scale-0 group-has-[input:checked]:scale-100 transition-transform',
            disabled ? 'bg-neutralPlus' : 'bg-black'
          )}
        ></span>
      </label>
      <label
        htmlFor={id}
        className={cn(
          'text-base/[175%] font-semibold mt-0.5',
          disabled ? 'text-neutralPlus cursor-default' : 'cursor-pointer',
          labelClassName
        )}
      >
        {label}
      </label>
    </div>
  );
};
